import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styles from "./profile.module.css";
import { Col, Row, Spinner, Alert, Button } from "react-bootstrap";
import Header from "../../Component/Header/Header";
import axios from "axios";
import { GET_PROFILE_URL, UPDATE_PROFILE_URL } from "../../APIs/BaseUrl";

const Account = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState("");

  // Local state for form fields
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    bio: "",
    bank_name: "",
    account_no: "",
    ifsc_code: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(GET_PROFILE_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setProfile(res.data?.data);
        setForm({
          name: res.data?.data?.user_id?.name || "",
          email: res.data?.data?.user_id?.email || "",
          phone: res.data?.data?.user_id?.phone || "",
          company: res.data?.data?.company || "",
          bio: res.data?.data?.bio || "",
          bank_name: res.data?.data?.bank_account_details?.bank_name || "",
          account_no: res.data?.data?.bank_account_details?.account_no || "",
          ifsc_code: res.data?.data?.bank_account_details?.ifsc_code || "",
        });
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load profile.");
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
  };

  const handleSave = async () => {
    setSaving(true);
    setError("");
    setSuccess("");
    const token = localStorage.getItem("token");
    try {
      await axios.put(
        UPDATE_PROFILE_URL,
        {
          name: form.name,
          email: form.email,
          phone: form.phone,
          company: form.company,
          bio: form.bio,
          bank_account_details: {
            bank_name: form.bank_name,
            account_no: form.account_no,
            ifsc_code: form.ifsc_code,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSuccess("Profile updated successfully.");
      setEditMode(false);
      // Optionally, refresh profile data
    } catch (err) {
      setError("Failed to update profile.");
    }
    setSaving(false);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  const isCompleted = profile?.user_id?.is_completed;

  return (
    <React.Fragment>
      <div className="right-aside">
        <Helmet>Profile</Helmet>
        <Row>
          <Col md={8} sm={12}>
            <Header />
            <div className={styles.main_section}>
              <div className={styles.headerSection}>
                <h6>My Profile</h6>
                {!isCompleted && (
                  <Button
                    variant={editMode ? "secondary" : "primary"}
                    size="sm"
                    onClick={() => setEditMode((prev) => !prev)}
                    className="ms-2"
                  >
                    {editMode ? "Cancel" : "Edit"}
                  </Button>
                )}
              </div>
              {success && <Alert variant="success">{success}</Alert>}
              {error && <Alert variant="danger">{error}</Alert>}
              {/* Avatar */}
              <div className={styles.userMain}>
                <div className={styles.user}>
                  <div>
                    <h6>Avatar</h6>
                    <p>Edit Your Profile</p>
                  </div>
                  <div>
                    <img
                      src={profile?.profileUrl || "/images/user_detail.png"}
                      alt="user_detail"
                      style={{ width: 80, height: 80, borderRadius: "50%" }}
                    />
                  </div>
                </div>
              </div>
              {/* Personal Info */}
              <div className={styles.userMain}>
                <div className={`${styles.user} ${styles.user_field}`}>
                  <div>
                    <h6>Personal Information</h6>
                    <p>Change Your Information here</p>
                  </div>
                  <div className={styles.input_section}>
                    <label htmlFor="name">Name</label>
                    <br />
                    <input
                      type="text"
                      id="name"
                      placeholder="Name"
                      value={form.name}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                    <label htmlFor="email">Email</label>
                    <br />
                    <input
                      type="text"
                      id="email"
                      placeholder="Email"
                      value={form.email}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                    <label htmlFor="phone">Phone Number</label>
                    <br />
                    <input
                      type="text"
                      id="phone"
                      placeholder="Phone"
                      value={form.phone}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                  </div>
                </div>
              </div>
              {/* Organization */}
              <div className={styles.userMain}>
                <div className={`${styles.user} ${styles.user_field}`}>
                  <div>
                    <h6>Organization Details</h6>
                    <p>Change Your Information here</p>
                  </div>
                  <div className={styles.input_section}>
                    <label htmlFor="company">Company Name</label>
                    <br />
                    <input
                      type="text"
                      id="company"
                      placeholder="Company"
                      value={form.company}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                    <label htmlFor="bio">Bio</label>
                    <br />
                    <input
                      type="text"
                      id="bio"
                      placeholder="Bio"
                      value={form.bio}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                  </div>
                </div>
              </div>
              {/* Bank */}
              <div className={styles.userMain}>
                <div className={`${styles.user} ${styles.user_field}`}>
                  <div>
                    <h6>Bank Account Details</h6>
                    <p>Change Your Information here</p>
                  </div>
                  <div className={styles.input_section}>
                    <label htmlFor="bank_name">Bank Name</label>
                    <br />
                    <input
                      type="text"
                      id="bank_name"
                      placeholder="Bank Name"
                      value={form.bank_name}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                    <label htmlFor="account_no">Account No</label>
                    <br />
                    <input
                      type="text"
                      id="account_no"
                      placeholder="Account No"
                      value={form.account_no}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                    <label htmlFor="ifsc_code">IFSC Code</label>
                    <br />
                    <input
                      type="text"
                      id="ifsc_code"
                      placeholder="IFSC Code"
                      value={form.ifsc_code}
                      onChange={handleChange}
                      readOnly={!editMode}
                    />
                  </div>
                </div>
              </div>
              {/* Save Button */}
              {editMode && (
                <div className="mt-3">
                  <Button variant="success" onClick={handleSave} disabled={saving}>
                    {saving ? "Saving..." : "Save"}
                  </Button>
                </div>
              )}
            </div>
          </Col>
          <Col md={4} className="p-0">
            {/* <Notification /> */}
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Account;
